import frLocale from 'element-ui/lib/locale/lang/fr'

export default {
  Dashboard: 'Tableau de bord',
  Analytics: 'Analytics',
  Business: 'Business',
  Method: 'Method',
  Channel: 'Channel',
  Transactions: 'Transactions',
  List: 'Lister',
  Refund: 'Refund',
  Merchants: 'Marchands',
  Commercial: 'Commercial',
  Channels: 'Canaliser',
  Management: 'Management',
  Promotions: 'Promotions',
  Financial: 'Financier',
  Payments: 'Paiements',
  Download: 'Télécharger',
  BankBills: 'Banque Bills',
  Query: 'Query',
  AntiFraud: 'Anti-Fraude',
  Anonymous: 'Anonyme',
  Sanctions: 'Sanctions',
  Development: 'Development',
  Calendar: 'Calendar',
  V1Import: 'V1 Import',
  Backdoor: 'Backdoor',
  Settlement: 'Settlement',
  Manual: 'Manual',
  Report: 'Report',
  Invoice: 'Invoice',
  Payout: 'Payout',
  PayoutDownload: 'Download',
  Switcher: 'Switcher',
  Users: 'Users',
  Edit: 'Edit',
  Admin: 'Admin',
  AntiMoneyLaundry: 'AML',
  Review: 'Review',
  Rules: 'Rules',
  Recurring: 'Recurring',
  IdManagement: 'ID Management',
  Blacklist: 'Blacklist',
  RuleManagement: 'Rule Management',
  AmlRuleManagement: 'Rule Management',
  Group: 'Group',
  TongDun: 'TongDun',
  Policy: 'Policy',
  Invoke: 'Invoke',
  RiskTrend: 'Risk Trend',
  KYC: 'KYC',
  APP: 'APP',
  Training: 'Formation',
  Waybill: 'Waybill',
  Upload: 'Upload',
  PayoutAccount: 'Payout Account',
  Registration: 'Registration',
  Reseller: 'Reseller',
  ResellerUsers: 'Resellers',
  ResellerManagement: 'Reseller Management',
  ResellerKyc: 'KYC Management',
  VirtualAccount: 'Virtual Account',
  ...frLocale,
}
